"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));

var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));

var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));

var prop_types_1 = __importDefault(require("prop-types"));

var handleCloseDefault = function handleCloseDefault(a) {
  return undefined;
};

function AlertDialog(props) {
  var open = props.open,
      _props$handleClose = props.handleClose,
      handleClose = _props$handleClose === void 0 ? handleCloseDefault : _props$handleClose;
  return react_1.default.createElement(Dialog_1.default, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, react_1.default.createElement(DialogTitle_1.default, {
    id: "alert-dialog-title"
  }, "Are you sure you would like to delete that record?"), react_1.default.createElement(DialogActions_1.default, null, react_1.default.createElement(Button_1.default, {
    onClick: function onClick() {
      return handleClose(false);
    },
    color: "primary"
  }, "No"), react_1.default.createElement(Button_1.default, {
    onClick: function onClick() {
      return handleClose(true);
    },
    color: "primary",
    autoFocus: true
  }, "Yes")));
}

exports.default = AlertDialog;
AlertDialog.propTypes = {
  open: prop_types_1.default.bool.isRequired,
  handleClose: prop_types_1.default.func.isRequired
};